// constants
export const HOME = '/';
export const SSO_AUTORIZE = '/oauth2/authorize/handler';
export const SSO_AUTHORIZE_EMPTY = '/oauth2/authorize';
export const AUTH0_LOGIN_CALLBACK = '/auth0/login/callback';
export const USERS = '/users';
export const USER = '/users/users/:id';
export const SIGN_IN = '/sign-in';
export const SIGN_IN_CONFIRMATION = '/sign-in/confirmation';
export const RESTORE_PASSWORD = '/restore-password';
export const SET_PASSWORD = '/set-password/:resetPasswordToken';
export const TOS = '/tos';
export const CONTACT = '/contact-us';
export const PRIVACY_POLICY = '/privacy-policy';
export const SETTINGS = '/settings';
export const PROFILE = '/profile';
export const STYLEGUIDE = '/styleguide';
export const MASTER_DATA = '/master-data';
export const ROLES = '/users/roles';
export const ROLE = '/users/roles/:id';
export const FILTERING_RULES = '/users/filtering-rules';
export const FILTERING_RULE = '/users/filtering-rules/:id';
export const COMPANY_TYPES = '/master-data/company-types';
export const COMPANY_TYPE = '/master-data/company-types/:id';
export const COMPANY_TYPE_VERSIONS = '/master-data/company-types/:id/versions';
export const REGIONS = '/master-data/regions';
export const REGION = '/master-data/regions/:id';
export const REGION_VERSIONS = '/master-data/regions/:id/versions';
export const COMPANIES = '/master-data/companies';
export const COMPANY = '/master-data/companies/:id';
export const COMPANY_VERSIONS = '/master-data/companies/:id/versions';
export const COMPANY_PROGRAMS = '/master-data/company-programs';
export const COMPANY_PROGRAM = '/master-data/company-programs/:id';
export const COMPANY_PROGRAM_VERSIONS = '/master-data/company-programs/:id/versions';
export const COMPANY_ADDRESSES = '/master-data/company-addresses';
export const COMPANY_ADDRESS = '/master-data/company-addresses/:id';
export const COMPANY_ADDRESS_VERSIONS = '/master-data/company-addresses/:id/versions';
export const WORKFORCE_LINKS = '/master-data/workforce-links';
export const WORKFORCE_LINK = '/master-data/workforce-links/:id';
export const WORKFORCE_LINK_VERSIONS = '/master-data/workforce-links/:id/versions';
export const COMPANY_LINKS = '/master-data/company-links';
export const COMPANY_LINK = '/master-data/company-links/:id';
export const COMPANY_LINK_VERSIONS = '/master-data/company-links/:id/versions';
export const WORKFORCE_HOLIDAYS = '/master-data/workforce-holidays';
export const WORKFORCE_HOLIDAY = '/master-data/workforce-holidays/:id';
export const WORKFORCE_HOLIDAY_VERSIONS = '/master-data/workforce-holidays/:id/versions';
export const WORKFORCE_TAXONOMIES = '/master-data/workforce-taxonomies';
export const WORKFORCE_TAXONOMY = '/master-data/workforce-taxonomies/:id';
export const WORKFORCE_TAXONOMY_VERSIONS = '/master-data/workforce-taxonomies/:id/versions';
export const ADDRESS_TYPES = '/master-data/address-types';
export const ADDRESS_TYPE = '/master-data/address-types/:id';
export const ADDRESS_TYPE_VERSIONS = '/master-data/address-types/:id/versions';
export const LINK_TYPES = '/master-data/link-types';
export const LINK_TYPE = '/master-data/link-types/:id';
export const LINK_TYPE_VERSIONS = '/master-data/link-types/:id/versions';
export const RESULT_CATEGORIES = '/master-data/result-categories';
export const RESULT_CATEGORY = '/master-data/result-categories/:id';
export const RESULT_CATEGORY_VERSION = '/master-data/result-categories/:id/versions';
export const RESULT_FAMILIES = '/master-data/result-families';
export const RESULT_FAMILY = '/master-data/result-families/:id';
export const RESULT_FAMILY_VERSION = '/master-data/result-families/:id/versions';
export const RESULTS = '/master-data/results';
export const RESULT = '/master-data/results/:id';
export const RESULT_VERSIONS = '/master-data/results/:id/versions';
export const LAW_CATEGORIES = '/master-data/law-categories';
export const LAW_CATEGORY = '/master-data/law-categories/:id';
export const LAW_CATEGORY_VERSIONS = '/master-data/law-categories/:id/versions';
export const CURRENCIES = '/master-data/currencies';
export const CURRENCY = '/master-data/currencies/:id';
export const DEPARTMENTS = '/master-data/departments';
export const DEPARTMENT = '/master-data/departments/:id';
export const DEPARTMENT_VERSIONS = '/master-data/departments/:id/versions';
export const SECTORS = '/master-data/sectors';
export const SECTOR = '/master-data/sectors/:id';
export const SECTOR_VERSIONS = '/master-data/sectors/:id/versions';
export const REPORT_TEMPLATES = '/master-data/report-templates';
export const REPORT_TEMPLATE = '/master-data/report-templates/:id';
export const EMAIL_TEMPLATES = '/master-data/email-templates';
export const EMAIL_TEMPLATE = '/master-data/email-templates/:id';
export const EMAIL_TEMPLATE_VERSIONS = '/master-data/email-templates/:id/versions';
export const NOTIFICATIONS = '/notifications/notifications';
export const NOTIFICATION = '/notifications/notifications/:id';
export const UNITS = '/master-data/units';
export const UNIT = '/master-data/units/:id';
export const ERSA_MAPPINGS = '/master-data/ersa-mappings';
export const ERSA_MAPPING = '/master-data/ersa-mappings/:id';
export const SEVERITIES = '/master-data/severities';
export const SEVERITY = '/master-data/severities/:id';
export const OTHER_CODES = '/master-data/other-codes';
export const OTHER_CODE = '/master-data/other-codes/:id';
export const HOLIDAY_TYPES = '/master-data/holiday-types';
export const HOLIDAY_TYPE = '/master-data/holiday-types/:id';
export const TIMEZONES = '/master-data/timezones';
export const TIMEZONE = '/master-data/timezones/:id';
export const LANGUAGES = '/master-data/languages';
export const LANGUAGE = '/master-data/languages/:id';
export const BUSINESS_UNITS = '/master-data/business-units';
export const BUSINESS_UNIT = '/master-data/business-units/:id';
export const BUSINESS_UNIT_VERSIONS = '/master-data/business-units/:id/versions';
export const COUNTRIES = '/master-data/countries';
export const COUNTRY = '/master-data/countries/:id';
export const COUNTRY_VERSIONS = '/master-data/countries/:id/versions';
export const WORKFORCES = '/master-data/workforces';
export const WORKFORCE = '/master-data/workforces/:id';
export const WORKFORCE_VERSIONS = '/master-data/workforces/:id/versions';
export const PRODUCT_LINES = '/master-data/product-lines';
export const PRODUCT_LINE = '/master-data/product-lines/:id';
export const PRODUCT_LINE_VERSIONS = '/master-data/product-lines/:id/versions';
export const STATE_PROVINCES = '/master-data/state-provinces';
export const STATE_PROVINCE = '/master-data/state-provinces/:id';
export const TRAININGS = '/master-data/trainings';
export const TRAINING = '/master-data/trainings/:id';
export const TRAINING_VERSIONS = '/master-data/trainings/:id/versions';
export const SERVICE_TYPES = '/master-data/service-types';
export const SERVICE_TYPE = '/master-data/service-types/:id';
export const SERVICES = '/master-data/services';
export const SERVICE = '/master-data/services/:id';
export const SERVICE_VERSIONS = '/master-data/services/:id/versions';
export const SCHEMES = '/master-data/schemes';
export const SCHEME = '/master-data/schemes/:id';
export const SERVICE_ITEMS = '/master-data/service-items';
export const SERVICE_ITEM = '/master-data/service-items/:id';
export const SERVICE_ITEM_VERSIONS = '/master-data/service-items/:id/versions';
export const NON_COMPLIANCES = '/master-data/non-compliances';
export const NON_COMPLIANCE = '/master-data/non-compliances/:id';
export const LAWS = '/master-data/laws';
export const LAW = '/master-data/laws/:id';
export const LAW_VERSIONS = '/master-data/laws/:id/versions';
export const LAW_NON_COMPLIANCES = '/master-data/law-non-compliances';
export const LAW_NON_COMPLIANCE = '/master-data/law-non-compliances/:id';
export const OPERATING_OFFICES = '/master-data/operating-offices';
export const OPERATING_OFFICE = '/master-data/operating-offices/:id';
export const OPERATING_OFFICE_VERSIONS = '/master-data/operating-offices/:id/versions';
export const COMPANY_CONTACTS = '/master-data/company-contacts';
export const COMPANY_CONTACT = '/master-data/company-contacts/:id';
export const COMPANY_CONTACT_VERSIONS = '/master-data/company-contacts/:id/versions';
export const CHECKLIST_QUESTIONS = '/master-data/checklist-questions';
export const CHECKLIST_QUESTION = '/master-data/checklist-questions/:id';
export const CHECKLIST_QUESTION_VERSIONS = '/master-data/checklist-questions/:id/versions';
export const DATASHEET_QUESTIONS = '/master-data/datasheet-questions';
export const DATASHEET_QUESTION = '/master-data/datasheet-questions/:id';
export const DATASHEET_QUESTION_VERSIONS = '/master-data/datasheet-questions/:id/versions';
export const CHECKLISTS = '/master-data/checklists';
export const CHECKLIST = '/master-data/checklists/:id';
export const CHECKLIST_VERSIONS = '/master-data/checklists/:id/versions';
export const CHECKLISTS_COMPARE = '/master-data/checklists/compare';
export const CUSTOM_PANEL = '/master-data/custom-panels/:id';
export const CUSTOM_PANELS = '/master-data/custom-panels';
export const CUSTOM_PANEL_VERSIONS = '/master-data/custom-panels/:id/versions';
export const DATASHEETS = '/master-data/datasheets';
export const DATASHEET = '/master-data/datasheets/:id';
export const DATASHEET_VERSIONS = '/master-data/datasheets/:id/versions';
export const PROGRAM_CATEGORIES = '/master-data/program-categories';
export const PROGRAM_CATEGORY = '/master-data/program-categories/:id';
export const PROGRAM_CATEGORY_VERSIONS = '/master-data/program-categories/:id/versions';
export const COUNTRY_HOLIDAYS = '/master-data/country-holidays';
export const COUNTRY_HOLIDAY = '/master-data/country-holidays/:id';
export const COUNTRY_LANGUAGES = '/master-data/country-languages';
export const COUNTRY_LANGUAGE = '/master-data/country-languages/:id';
export const PRODUCT_TAXONOMIES = '/master-data/product-taxonomies';
export const PRODUCT_TAXONOMY = '/master-data/product-taxonomies/:id';
export const PRODUCT_TAXONOMY_VERSIONS = '/master-data/product-taxonomies/:id/versions';
export const RATINGS = '/master-data/ratings';
export const RATING = '/master-data/ratings/:id';
export const RATING_VERSIONS = '/master-data/ratings/:id/versions';
export const JOBS = '/jobs/jobs';
export const JOB = '/jobs/jobs/:id';
export const SCORINGS = '/master-data/scorings';
export const SCORING = '/master-data/scorings/:id';
export const TAG = '/master-data/tags/:id';
export const TAG_VERSIONS = '/master-data/tags/:id/versions';
export const TAGS = '/master-data/tags';
export const TAGS_CONFIGURATIONS = '/master-data/tags-configurations';
export const TAGS_CONFIGURATION = '/master-data/tags-configurations/:id';
export const TAGS_CONFIGURATION_VERSIONS = '/master-data/tags-configurations/:id/versions';
export const SURVEY_SKINS = '/master-data/survey-skins';
export const SURVEY_SKIN = '/master-data/survey-skins/:id';
export const PUBLIC_SURVEY = '/s/:code';
export const PUBLIC_SURVEY_DASHBOARD = '/s/dashboard/:code';
export const CREATE_JOB = '/master-data/create-job';
export const SSO_AUTH_ERROR = '/auth-error';

/*
 * Code for investigation results for PHX-2689. To be removed after acceptance.
 */
export const TEST_IMAGE_EDITING_PAGE = '/test-image-editing';

// helpers
export const makeAddressTypeUrl = (id = 'new') => ADDRESS_TYPE.replace(':id', id);
export const makeAddressTypeVersionsUrl = (id = 'new') => ADDRESS_TYPE_VERSIONS.replace(':id', id);
export const makeBusinessUnitUrl = (id = 'new') => BUSINESS_UNIT.replace(':id', id);
export const makeBusinessUnitVersionsUrl = (id = 'new') => BUSINESS_UNIT_VERSIONS.replace(':id', id);
export const makeChecklistCompareUrl = (id = 'new') => `${CHECKLISTS_COMPARE}?id=${id}`;
export const makeChecklistQuestionUrl = (id = 'new') => CHECKLIST_QUESTION.replace(':id', id);
export const makeChecklistQuestionVersionsUrl = (id = 'new') => CHECKLIST_QUESTION_VERSIONS.replace(':id', id);
export const makeChecklistUrl = (id = 'new') => CHECKLIST.replace(':id', id);
export const makeChecklistVersionsUrl = (id = 'new') => CHECKLIST_VERSIONS.replace(':id', id);
export const makeCompanyAddressUrl = (id = 'new') => COMPANY_ADDRESS.replace(':id', id);
export const makeCompanyAddressVersionsUrl = (id = 'new') => COMPANY_ADDRESS_VERSIONS.replace(':id', id);
export const makeCompanyContactUrl = (id = 'new') => COMPANY_CONTACT.replace(':id', id);
export const makeCompanyContactVersionsUrl = (id = 'new') => COMPANY_CONTACT_VERSIONS.replace(':id', id);
export const makeCompanyLinkUrl = (id = 'new') => COMPANY_LINK.replace(':id', id);
export const makeCompanyLinkVersionsUrl = (id = 'new') => COMPANY_LINK_VERSIONS.replace(':id', id);
export const makeCompanyProgramUrl = (id = 'new') => COMPANY_PROGRAM.replace(':id', id);
export const makeCompanyProgramVersionsUrl = (id = 'new') => COMPANY_PROGRAM_VERSIONS.replace(':id', id);
export const makeCompanyTypeUrl = (id = 'new') => COMPANY_TYPE.replace(':id', id);
export const makeCompanyTypeVersionsUrl = (id = 'new') => COMPANY_TYPE_VERSIONS.replace(':id', id);
export const makeCompanyUrl = (id = 'new') => COMPANY.replace(':id', id);
export const makeCompanyVersionsUrl = (id = 'new') => COMPANY_VERSIONS.replace(':id', id);
export const makeCountryHolidayUrl = (id = 'new') => COUNTRY_HOLIDAY.replace(':id', id);
export const makeCountryLanguageUrl = (id = 'new') => COUNTRY_LANGUAGE.replace(':id', id);
export const makeCountryUrl = (id = 'new') => COUNTRY.replace(':id', id);
export const makeCountryVersionsUrl = (id = 'new') => COUNTRY_VERSIONS.replace(':id', id);
export const makeCurrencyUrl = (id = 'new') => CURRENCY.replace(':id', id);
export const makeCustomPanelUrl = (id = 'new') => CUSTOM_PANEL.replace(':id', id);
export const makeCustomPanelVersionsUrl = (id = 'new') => CUSTOM_PANEL_VERSIONS.replace(':id', id);
export const makeDatasheetQuestionUrl = (id = 'new') => DATASHEET_QUESTION.replace(':id', id);
export const makeDatasheetQuestionVersionsUrl = (id = 'new') => DATASHEET_QUESTION_VERSIONS.replace(':id', id);
export const makeDatasheetUrl = (id = 'new') => DATASHEET.replace(':id', id);
export const makeDatasheetVersionsUrl = (id = 'new') => DATASHEET_VERSIONS.replace(':id', id);
export const makeDepartmentUrl = (id = 'new') => DEPARTMENT.replace(':id', id);
export const makeDepartmentVersionsUrl = (id = 'new') => DEPARTMENT_VERSIONS.replace(':id', id);
export const makeEmailTemplateUrl = (id = 'new') => EMAIL_TEMPLATE.replace(':id', id);
export const makeEmailTemplateVersionsUrl = (id = 'new') => EMAIL_TEMPLATE_VERSIONS.replace(':id', id);
export const makeErsaMappingUrl = (id = 'new') => ERSA_MAPPING.replace(':id', id);
export const makeFilteringRuleUrl = (id = 'new') => FILTERING_RULE.replace(':id', id);
export const makeHolidayTypeUrl = (id = 'new') => HOLIDAY_TYPE.replace(':id', id);
export const makeJobUrl = (id = 'new', tabId) => tabId ?
  `${JOB.replace(':id', id)}?tabId=${tabId}` :
  JOB.replace(':id', id);
export const makeLanguageUrl = (id = 'new') => LANGUAGE.replace(':id', id);
export const makeLawCategoryUrl = (id = 'new') => LAW_CATEGORY.replace(':id', id);
export const makeLawCategoryVersionsUrl = (id = 'new') => LAW_CATEGORY_VERSIONS.replace(':id', id);
export const makeLawNonComplianceUrl = (id = 'new') => LAW_NON_COMPLIANCE.replace(':id', id);
export const makeLawUrl = (id = 'new') => LAW.replace(':id', id);
export const makeLawVersionsUrl = (id = 'new') => LAW_VERSIONS.replace(':id', id);
export const makeLinkTypeUrl = (id = 'new') => LINK_TYPE.replace(':id', id);
export const makeLinkTypeVersionsUrl = (id = 'new') => LINK_TYPE_VERSIONS.replace(':id', id);
export const makeNonComplianceUrl = (id = 'new') => NON_COMPLIANCE.replace(':id', id);
export const makeNotificationUrl = (id = 'new') => NOTIFICATION.replace(':id', id);
export const makeOperatingOfficeUrl = (id = 'new') => OPERATING_OFFICE.replace(':id', id);
export const makeOperatingOfficeVersionsUrl = (id = 'new') => OPERATING_OFFICE_VERSIONS.replace(':id', id);
export const makeOtherCodeUrl = (id = 'new') => OTHER_CODE.replace(':id', id);
export const makeProductLineUrl = (id = 'new') => PRODUCT_LINE.replace(':id', id);
export const makeProductLineVersionsUrl = (id = 'new') => PRODUCT_LINE_VERSIONS.replace(':id', id);
export const makeProductTaxonomyUrl = (id = 'new') => PRODUCT_TAXONOMY.replace(':id', id);
export const makeProductTaxonomyVersionsUrl = (id = 'new') => PRODUCT_TAXONOMY_VERSIONS.replace(':id', id);
export const makeProgramCategoryUrl = (id = 'new') => PROGRAM_CATEGORY.replace(':id', id);
export const makeProgramCategoryVersionsUrl = (id = 'new') => PROGRAM_CATEGORY_VERSIONS.replace(':id', id);
export const makeRatingUrl = (id = 'new') => RATING.replace(':id', id);
export const makeRatingVersionsUrl = (id = 'new') => RATING_VERSIONS.replace(':id', id);
export const makeRegionUrl = (id = 'new') => REGION.replace(':id', id);
export const makeRegionVersionsUrl = (id = 'new') => REGION_VERSIONS.replace(':id', id);
export const makeReportTemplateUrl = (id = 'new') => REPORT_TEMPLATE.replace(':id', id);
export const makeResultCategoryUrl = (id = 'new') => RESULT_CATEGORY.replace(':id', id);
export const makeResultCategoryVersionsUrl = (id = 'new') => RESULT_CATEGORY_VERSION.replace(':id', id);
export const makeResultFamilyUrl = (id = 'new') => RESULT_FAMILY.replace(':id', id);
export const makeResultFamilyVersionsUrl = (id = 'new') => RESULT_FAMILY_VERSION.replace(':id', id);
export const makeResultUrl = (id = 'new') => RESULT.replace(':id', id);
export const makeResultVersionsUrl = (id = 'new') => RESULT_VERSIONS.replace(':id', id);
export const makeRoleUrl = (id = 'new') => ROLE.replace(':id', id);
export const makeSchemeUrl = (id = 'new') => SCHEME.replace(':id', id);
export const makeScoringUrl = (id = 'new') => SCORING.replace(':id', id);
export const makeSectorUrl = (id = 'new') => SECTOR.replace(':id', id);
export const makeSectorVersionsUrl = (id = 'new') => SECTOR_VERSIONS.replace(':id', id);
export const makeServiceItemUrl = (id = 'new') => SERVICE_ITEM.replace(':id', id);
export const makeServiceItemVersionsUrl = (id = 'new') => SERVICE_ITEM_VERSIONS.replace(':id', id);
export const makeServiceTypeUrl = (id = 'new') => SERVICE_TYPE.replace(':id', id);
export const makeServiceUrl = (id = 'new') => SERVICE.replace(':id', id);
export const makeServiceVersionsUrl = (id = 'new') => SERVICE_VERSIONS.replace(':id', id);
export const makeSetPasswordUrl = token => SET_PASSWORD.replace(':resetPasswordToken', token);
export const makeSeverityUrl = (id = 'new') => SEVERITY.replace(':id', id);
export const makeStateProvinceUrl = (id = 'new') => STATE_PROVINCE.replace(':id', id);
export const makeTagUrl = (id = 'new') => TAG.replace(':id', id);
export const makeTagVersionsUrl = (id = 'new') => TAG_VERSIONS.replace(':id', id);
export const makeTimezoneUrl = (id = 'new') => TIMEZONE.replace(':id', id);
export const makeTrainingUrl = (id = 'new') => TRAINING.replace(':id', id);
export const makeTrainingVersionsUrl = (id = 'new') => TRAINING_VERSIONS.replace(':id', id);
export const makeUnitUrl = (id = 'new') => UNIT.replace(':id', id);
export const makeUserUrl = (id = 'new') => USER.replace(':id', id);
export const makeWorkforceHolidayUrl = (id = 'new') => WORKFORCE_HOLIDAY.replace(':id', id);
export const makeWorkforceHolidayVersionsUrl = (id = 'new') => WORKFORCE_HOLIDAY_VERSIONS.replace(':id', id);
export const makeWorkforceLinkUrl = (id = 'new') => WORKFORCE_LINK.replace(':id', id);
export const makeWorkforceLinkVersionsUrl = (id = 'new') => WORKFORCE_LINK_VERSIONS.replace(':id', id);
export const makeWorkforceTaxonomyUrl = (id = 'new') => WORKFORCE_TAXONOMY.replace(':id', id);
export const makeWorkforceTaxonomyVersionsUrl = (id = 'new') => WORKFORCE_TAXONOMY_VERSIONS.replace(':id', id);
export const makeWorkforceUrl = (id = 'new') => WORKFORCE.replace(':id', id);
export const makeWorkforceVersionsUrl = (id = 'new') => WORKFORCE_VERSIONS.replace(':id', id);
export const makeTagsConfigurationUrl = (id = 'new') => TAGS_CONFIGURATION.replace(':id', id);
export const makeTagsConfigurationVersionsUrl = (id = 'new') => TAGS_CONFIGURATION_VERSIONS.replace(':id', id);
export const makeSurveySkinUrl = (id = 'new') => SURVEY_SKIN.replace(':id', id);
